/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router";
import { useSelector, useDispatch } from "react-redux";

import PropTypes from "prop-types";
import { checkUser } from "store/actions/userActions";
import Loading from "pages/loading";
// Images
import LokaleeIcon from "assets/images/Lokalee-logo.svg";
import LokaleeMiniIcon from "assets/images/Lokalee-icon-mini.svg";
// Material Dashboard 2 PRO React examples
import Sidenav from "components/Sidenav";

// Material Dashboard 2 PRO React contexts
import { useMaterialUIController, setMiniSidenav } from "context";

import routes from "concierge.routes";

const ConciergeRoute = ({ children = {} }) => {
  const [controller, dispatch] = useMaterialUIController();
  const isAuthenticated = useSelector((state) => state.users.isAuthenticated);
  const user = useSelector((state) => state.users.user);
  const loading = useSelector((state) => state.users.loading);
  const { miniSidenav } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const [initialCheckComplete, setInitialCheckComplete] = useState(false);

  // Close sidenav when mouse leave mini sidenav
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };
  // Open sidenav when mouse enter on mini sidenav
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  const dispatchRedux = useDispatch();
  useEffect(() => {
    // Always check user on component mount (page refresh)
    const checkAuthentication = async () => {
      if (!isAuthenticated && !initialCheckComplete) {
        await dispatchRedux(checkUser());
        setInitialCheckComplete(true);
      }
    };

    checkAuthentication();
  }, [dispatchRedux, isAuthenticated, initialCheckComplete]);

  // Show loading while checking authentication or if loading is true
  if (loading || (!isAuthenticated && !initialCheckComplete)) {
    return <Loading />;
  }

  // Only redirect after we've completed the initial authentication check
  if (initialCheckComplete && (!isAuthenticated || user?.role !== "concierge")) {
    return <Navigate to="/authentication/login" replace />;
  }

  if (isAuthenticated && user?.role === "concierge") {
    return (
      <>
        <Sidenav
          color="primaryC"
          brand={miniSidenav ? LokaleeMiniIcon : LokaleeIcon}
          routes={routes}
          onMouseEnter={handleOnMouseEnter}
          onMouseLeave={handleOnMouseLeave}
        />
        {children}
      </>
    );
  }

  // Fallback loading state
  return <Loading />;
};

ConciergeRoute.propTypes = {
  children: PropTypes.instanceOf(Object),
};

export default ConciergeRoute;
